import { FC } from "react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  } from "@/components/ui/dropdown-menu"
  

interface Item {
    title: string;
    icon?: React.ReactNode;
}

interface CDropdownProps {
  children: React.ReactNode;
  items: Item[];
  textStyles?: string;
  onChange: (item: Item) => void;
  disabled?: boolean;
}
 
const CDropdown: FC<CDropdownProps> = ({ children, items, onChange, disabled }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="outline-0" disabled={disabled}>
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-gray-300">
        {items.map((item, index) => (
          <DropdownMenuItem
            onClick={() => onChange(item)}
            key={index}
            className="textStyles"
          >
            {item.icon}
            {item.title}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
 
export default CDropdown;